var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 6H17.5V4C17.5 2.897 16.603 2 15.5 2H9.5C8.397 2 7.5 2.897 7.5 4V6H4.5C3.397 6 2.5 6.897 2.5 8V19C2.5 20.103 3.397 21 4.5 21H20.5C21.603 21 22.5 20.103 22.5 19V8C22.5 6.897 21.603 6 20.5 6ZM15.5 4V6H9.5V4H15.5ZM8.5 8H16.5H20.5V11H4.5V8H8.5ZM4.5 19V13H10.5V15H14.5V13H20.5L20.501 19H4.5Z",
    fill: "#C10037"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryIcon);
export default __webpack_public_path__ + "static/media/category-icon.a85144488e736eed92d72019100ee959.svg";
export { ForwardRef as ReactComponent };